export default __webpack_public_path__ + "static/homeoffer-a7e23bbaccd196f9e973c18014c9cba4.jpg";